<template>
  <div v-if="model">
    <h5 class="info-text">Let's start with the basic information</h5>
    <div class="row">
      <div class="form-group col-4" v-if="false">
        <label>User Id</label>
        <fg-input name="user_id" placeholder="User Id" v-model="model.user_id" readonly></fg-input>
      </div>

      <div class="form-group col-4" v-if="false">
        <label>User Id</label>
        <fg-input name="user_id" placeholder="User Id" v-model="model.patient_id" readonly></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Name</label>
        <fg-input
          readonly
          type="text"
          name="name"
          placeholder="Name"
          v-model="model.name"
          v-validate="modelValidations.name"
          :error="getError('name')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Phone</label>
        <fg-input
          readonly
          type="text"
          name="phone"
          placeholder="Phone"
          v-model="model.phone"
          v-validate="modelValidations.phone"
          :error="getError('phone')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Alternative Phone</label>
        <fg-input
          readonly
          type="text"
          name="alt_phone"
          placeholder="Alternative Phone"
          v-model="model.alt_phone"
          v-validate="modelValidations.alt_phone"
          :error="getError('alt_phone')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Email</label>
        <fg-input
        readonly
          type="email"
          name="email"
          placeholder="Email"
          v-model="model.email"
          v-validate="modelValidations.email"
          :error="getError('email')"
        ></fg-input>
      </div>

      <div class="form-group col-3">
        <label for>DOB</label>
        <fg-input
          readonly
          name="dob"
          v-model="model.dob"
          type="date"
          placeholder="Pick DOB"
          v-validate="modelValidations.dob"
          :error="getError('dob')"
        >
          <el-date-picker
          readonly
            name="dob"
            v-model="model.dob"
            type="date"
            placeholder="Pick DOB"
            v-validate="modelValidations.dob"
          ></el-date-picker>
        </fg-input>
      </div>

      <div class="form-group col-1">
        <label for>Age</label>
        <fg-input
          readonly
          type="number"
          name="age"
          placeholder="Age"
          v-model="age"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Father's Name</label>
        <fg-input
        readonly
          type="text"
          name="father_name"
          placeholder="Father's Name"
          v-model="model.father_name"
          v-validate="modelValidations.father_name"
          :error="getError('father_name')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Mother's Name</label>
        <fg-input
        readonly
          type="text"
          name="mother_name"
          placeholder="Mother's Name"
          v-model="model.mother_name"
          v-validate="modelValidations.mother_name"
          :error="getError('mother_name')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Spouse's Name</label>
        <fg-input
        readonly
          type="text"
          name="spouse_name"
          placeholder="Spouse's Name"
          v-model="model.spouse_name"
          v-validate="modelValidations.spouse_name"
          :error="getError('')"
        ></fg-input>
      </div>

      <div class="form-group col-4">
        <label for>Maritial Status</label>
         <fg-input
        readonly
          type="text"
          name="spouse_name"
          placeholder="Spouse's Name"
          v-model="model.maritial_status"
          v-validate="modelValidations.spouse_name"
          :error="getError('')"
        ></fg-input>
      </div>
      </div>

      <div class="form-group col-4">
        <label for>Gender</label>
         <fg-input
        readonly
          type="text"
          name="spouse_name"
          placeholder="Spouse's Name"
          v-model="model.gender"
          v-validate="modelValidations.spouse_name"
          :error="getError('')"
        ></fg-input>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Upload, DatePicker, Select, Option } from "element-ui";
import { mapGetters } from "vuex";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed: {
    ...mapGetters({
      genders: "getGenders",
      maritial_statuses: "getMaritalStatuses",
      religions: "getReligions"
    }),
    age: function() {
      const getAge = birthDate =>{
          if(typeof(birthDate) == 'string'){
            birthDate = birthDate.split('-');
            return Math.floor((new Date() - new Date(birthDate[0], birthDate[1], birthDate[2]).getTime()) / 3.15576e10);        
          }
          else{
            return Math.floor((new Date() - birthDate.getTime()) / 3.15576e10);
          }
      }

      if (this.model.dob) return getAge(this.model.dob);
      else return null;
    }
  },
  props: ['model'],
  data() {
    return {
      modelValidations: {
        name: {
          required: false
        },
        phone: {
          // required: false,
          min: 10,
          max: 10
        },
        email: {
          required: false,
          email: false
        },
        dob: {
          required: false
        },
        gender: {
          required: false
        },
        father_name: {
          required: false
        },
        mother_name: {
          required: false
        },
        maritial_status: {
          requried: false
        },
        religions: {
          required: false
        }
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    }
  }
};
</script>
<style lang="scss">
.card-wizard .picture-container .picture {
  input[type="file"] {
    display: none;
  }
}
</style>
